var map = {
	"./AD.png": 3591,
	"./AE.png": 1630,
	"./AG.png": 83532,
	"./AM.png": 14358,
	"./AR.png": 481,
	"./AT.png": 7383,
	"./AU.png": 64366,
	"./BE.png": 57215,
	"./BF.png": 71940,
	"./BG.png": 35181,
	"./BO.png": 34357,
	"./BR.png": 3376,
	"./CA.png": 29204,
	"./CD.png": 71545,
	"./CG.png": 57538,
	"./CH.png": 58405,
	"./CL.png": 22721,
	"./CM.png": 50008,
	"./CN.png": 24499,
	"./CO.png": 73738,
	"./CZ.png": 25831,
	"./DE.png": 26873,
	"./DJ.png": 11310,
	"./DK.png": 40535,
	"./DZ.png": 13822,
	"./EE.png": 14866,
	"./EG.png": 38848,
	"./EN.png": 51857,
	"./ES.png": 86452,
	"./FI.png": 35759,
	"./FR.png": 35948,
	"./GA.png": 5472,
	"./GB.png": 60507,
	"./GM.png": 80620,
	"./GT.png": 22621,
	"./HN.png": 29966,
	"./HT.png": 14692,
	"./HU.png": 77933,
	"./ID.png": 50687,
	"./IE.png": 53750,
	"./IL.png": 455,
	"./IN.png": 50069,
	"./IQ.png": 28610,
	"./IR.png": 95193,
	"./IT.png": 74319,
	"./JM.png": 13519,
	"./JO.png": 55709,
	"./JP.png": 22298,
	"./KG.png": 72634,
	"./KN.png": 17083,
	"./KP.png": 96325,
	"./KR.png": 67543,
	"./KW.png": 11658,
	"./KZ.png": 89583,
	"./LA.png": 37493,
	"./LB.png": 51742,
	"./LC.png": 39431,
	"./LS.png": 78455,
	"./LU.png": 66945,
	"./LV.png": 36362,
	"./MG.png": 81880,
	"./MK.png": 32340,
	"./ML.png": 98603,
	"./MM.png": 61122,
	"./MT.png": 53539,
	"./MX.png": 6879,
	"./NA.png": 26735,
	"./NE.png": 71531,
	"./NG.png": 47609,
	"./NI.png": 74071,
	"./NL.png": 15626,
	"./NO.png": 73057,
	"./OM.png": 7188,
	"./PA.png": 64433,
	"./PE.png": 14069,
	"./PG.png": 16007,
	"./PK.png": 27419,
	"./PL.png": 17476,
	"./PT.png": 96924,
	"./PY.png": 41369,
	"./QA.png": 65354,
	"./RO.png": 62629,
	"./RU.png": 79679,
	"./RW.png": 96717,
	"./SA.png": 75364,
	"./SE.png": 78688,
	"./SG.png": 42802,
	"./SL.png": 61969,
	"./SN.png": 33027,
	"./SO.png": 31802,
	"./SV.png": 29675,
	"./TD.png": 1952,
	"./TJ.png": 34206,
	"./TL.png": 7080,
	"./TR.png": 79014,
	"./TZ.png": 8398,
	"./UA.png": 31430,
	"./US.png": 52484,
	"./VE.png": 48707,
	"./VN.png": 5760,
	"./YE.png": 6406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35163;